const normalizeNumber = (value) => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : value;
  }
  return value;
};

export const normalizeUserId = (value) => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  if (value && typeof value === 'object' && typeof value._id === 'string') return value._id;
  return value ?? '';
};

export const normalizeCreateUserPayload = (payload) => {
  if (!payload || typeof payload !== 'object') return {};
  const normalized = {
    privilege: normalizeNumber(payload.privilege),
    username: payload.username,
    name: payload.name,
    email: payload.email,
  };
  if (payload.tenantId !== undefined) {
    normalized.tenantId = payload.tenantId;
  }
  return normalized;
};

export const normalizeUpdateUserPayload = (payload) => {
  if (!payload || typeof payload !== 'object') return {};
  return {
    email: payload.email,
    name: payload.name,
    privilege: normalizeNumber(payload.privilege),
    username: payload.username,
  };
};

const normalizeCodePayload = (payload) => {
  if (!payload || typeof payload !== 'object') return {};
  return {
    code: payload.code,
  };
};

export const normalizeLoginPayload = (payload) => {
  return normalizeCodePayload(payload);
};

export const normalizeVerifyEmailChangePayload = (payload) => {
  return normalizeCodePayload(payload);
};

export const normalizeTermsAgreePayload = (payload) => {
  if (!payload || typeof payload !== 'object') return {};
  return {
    docName: payload.docName,
    version: payload.version,
  };
};

export const normalizeConfigMfaPayload = (payload) => {
  if (!payload || typeof payload !== 'object') return {};
  const normalized = {};
  if (payload.method !== undefined) normalized.method = payload.method;
  if (payload.password !== undefined) normalized.password = payload.password;
  if (payload.phone !== undefined) normalized.phone = payload.phone;
  return normalized;
};

export const normalizeValidateMfaPayload = (payload) => {
  if (!payload || typeof payload !== 'object') return {};
  const normalized = {
    code: payload.code,
  };
  if (payload.method !== undefined) normalized.method = payload.method;
  if (payload.session !== undefined) normalized.session = payload.session;
  return normalized;
};

export const normalizeDisableMfaPayload = (payload) => {
  if (!payload || typeof payload !== 'object') return {};
  const normalized = {};
  if (payload.method !== undefined) normalized.method = payload.method;
  return normalized;
};

export const normalizePreferredMfaPayload = (payload) => {
  if (!payload || typeof payload !== 'object') return {};
  return {
    method: payload.method,
  };
};

export const normalizeSetTenantIdPayload = (payload) => {
  if (!payload || typeof payload !== 'object') return {};
  return {
    tenantId: payload.tenantId,
  };
};
